import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, collection, doc, getDoc, onSnapshot, where, query, limit, getDocs, orderBy } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';  // <-- thêm dòng này

const firebaseConfig = {
  apiKey: 'N9xHRFcafDcOdIEEtNnMVNbZiwEITleGzATRlLwR',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};
console.log("Loaded REACT_APP_FIREBASE_STORAGE_BUCKET =", process.env.REACT_APP_FIREBASE_STORAGE_BUCKET);

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
export { auth, db, collection, doc, getDoc, onSnapshot, where, query, limit, getDocs, orderBy, storage };